const paymentCz = {
    "billing": {
        "name": "Jméno/název společnosti",
        "country": "Země",
        "postal_code": "Poštovní směrovací číslo",
        "city": "Město",
        "address": "Adresa",
        "tax_number": "Daňové číslo",
        "phone": "Telefonní číslo",
        "tax_number_helper_text": "Povinné pro firmy, ne pro jednotlivce",
        "billing_info": "Fakturační údaje",
        "emails_helper_text": "Volitelné. Více e-mailových adres oddělte čárkami."
    },
    "subscription_plans": {
        "PRO": "Profesionální plán",
        "FREE": "Bezplatný tarif"
    },
    "plan_descriptions": {
        "PRO": "Pro restaurace, které chtějí posunout své podnikání na další úroveň! Přeložte si menu do nových jazyků jen několika kliknutími, požádejte hosty o zpětnou vazbu k jejich pokrmům, sledujte používání menu pomocí QR kódu s užitečnými statistikami nebo nechte QuickPick AI automaticky reagovat na zpětnou vazbu vašich hostů ve vašem stylu!",
        "FREE": "Pro restaurace, které chtějí začít s online menu a QR kódy."
    },
    "subscription_status": {
        "ACTIVE": "Aktivní",
        "CANCELLED": "Zrušeno"
    },
    "next_billing_date": "Další datum fakturace",
    "current_subscription": "Aktuální předplatné",
    "cancel": "Zrušit",
    "subscription_interval_prices": {
        "MONTHLY": "měsíc",
        "YEARLY": "rok",
        "HALF_YEARLY": "půl roku",
        "QUARTERLY": "čtvrtletí"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Měsíční předplatné",
        "YEARLY": "Roční předplatné",
        "HALF_YEARLY": "Půlroční předplatné",
        "QUARTERLY": "Čtvrtletní předplatné"
    },
    "reactivate": "Znovu aktivovat",
    "valid_to": "Platné do",
    "payments_and_invoices": "Platby a faktury",
    "amount": "Množství",
    "invoice": "Faktura",
    "update_card": "Aktualizovat",
    "payment_method": "Způsob platby",
    "cancel_subscription_confirmation": "Opravdu chcete zrušit své aktuální předplatné?",
    "cancel_subscription_valid_until": "Předplatné zůstane platné do následujícího data.",
    "subscription_cancelled": "Předplatné bylo úspěšně zrušeno",
    "reactivate_confirmation": "Opravdu chcete znovu aktivovat zrušené předplatné?",
    "reactivate_successful": "Předplatné bylo úspěšně znovu aktivováno",
    "change_payment_method": "Změnit způsob platby",
    "change_payment_method_tooltip": "Chcete-li změnit platební údaje, musíte zaplatit za další období předplatného. Vaše předplatné se samozřejmě prodlouží o délku období a další fakturační datum bude splatné o stejnou dobu později.",
    "amount_to_be_paid": "Částka k úhradě",
    "new_subscription_valid_until": "Nová platnost předplatného",
    "bank_card_expires_soon": "Platnost bankovní karty použité pro předplatné brzy vyprší.",
    "reactivate_subscription_confirmation": "Opravdu chcete znovu aktivovat zrušené předplatné?",
    "billing_information": "Fakturační informace",
    "edit_billing_information": "Upravit fakturační údaje",
    "no_available_invoices": "Žádné faktury k dispozici",
    "subscribe": "Upsat",
    "continue_to_payment": "Pokračovat k platbě",
    "confirm_subscription": "Potvrdit předplatné",
    "subscription_page_title": "Zahájit předplatné",
    "pay": "Platba",
    "available_plans": "Dostupné předplatné",
    "accept_terms_and_conditions": "Přečetl(a) jsem si a souhlasím s <a>Smluvními podmínkami</a>",
    "accept_recurring_payments": "Platbou souhlasím s automatickým účtováním opakovaných plateb, které mohu kdykoli zrušit.",
    "accept_privacy_policy": "Přečetl(a) jsem si a souhlasím se <a>Zásadami ochrany osobních údajů</a>",
    "subscribe_soon": "Již brzy"
};

export default paymentCz;
